import ButtonsBlock from '@/components/common/buttons-block/buttons-block';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import FormInputsSeparator from '@/components/common/form-inputs-separator/form-inputs-separator';
import { CHANGE_PASSWORD, USERS } from '@/utils/CONST';
import { composeUri } from '@/utils/compose';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Form, PasswordInput, required, useNotify, useTranslate, useUpdate } from 'react-admin';
import { useNavigate, useParams } from 'react-router';

const EditUserPassDialog = () => {
    const { userId = '' } = useParams();
    const navigate = useNavigate();
    const translate = useTranslate();
    const [update, { isLoading: isLoadingUpdate }] = useUpdate();
    const notify = useNotify();

    const navigateBack = () => {
        navigate(-1);
    };

    const handleSubmit = ({ password, confirm_password }: any) => {
        if (password !== confirm_password) {
            notify('messages.password_mismatch', {
                type: 'error',
            });
        } else
            update(
                USERS,
                {
                    id: composeUri(CHANGE_PASSWORD, userId),
                    data: {
                        plainPassword: password,
                    },
                },
                {
                    onSuccess: () => {
                        notify('messages.password_updated', {
                            type: 'success',
                        });
                        navigateBack();
                    },
                },
            );
    };

    return (
        <DialogTemplate open={true} maxWidth={'sm'} onClose={navigateBack} title={translate('users.change_pass')}>
            <Form onSubmit={handleSubmit}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 2,
                    }}
                >
                    <FormInputsSeparator>
                        <PasswordInput
                            source='password'
                            label='users.form.password'
                            helperText={false}
                            validate={[required()]}
                        />

                        <PasswordInput
                            source='confirm_password'
                            label='users.form.confirm_password'
                            helperText={false}
                            validate={[required()]}
                        />
                    </FormInputsSeparator>

                    <ButtonsBlock>
                        <ButtonsBlock>
                            <Button disabled={isLoadingUpdate} onClick={navigateBack}>
                                {translate('ra.action.cancel')}
                            </Button>

                            <LoadingButton variant={'contained'} type={'submit'} loading={isLoadingUpdate}>
                                {translate('ra.action.edit')}
                            </LoadingButton>
                        </ButtonsBlock>
                    </ButtonsBlock>
                </Box>
            </Form>
        </DialogTemplate>
    );
};

export default EditUserPassDialog;
